import type { DocumentSource } from '@allemnii-pulse/shared';
import { Badge } from './Badge.js';

const SOURCE_LABEL: Record<DocumentSource, string> = {
  manual: 'Manual',
  llm: 'AI generated',
};

/** Shows whether a task was added by hand or produced by generation/regeneration — purely
 * informational (see Task.source in packages/shared/src/schemas/task.ts). */
export function SourceBadge({ source }: { source: DocumentSource }) {
  return <Badge variant={source === 'manual' ? 'secondary' : 'outline'}>{SOURCE_LABEL[source]}</Badge>;
}
